import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Collapse, Card, CardBody } from 'reactstrap'
import { CustomPayment } from './Tabs'

import './styles.scss'

export default class PluginPayment extends React.Component {
  constructor() {
    super()
    this.state = { open: false }
    this.onToggle = this.onToggle.bind(this)
  }

  onToggle(isRemoveByUser) {
    this.setState((prevState) => ({ open: isRemoveByUser ? false : !prevState.open }))
  }

  render() {
    const { user } = this.props
    const { open } = this.state

    return (
      <div className={`plugin-sales-card ${user.isRemoveByUser ? 'disabled' : ''}`}>
        <div className='title-container'>
          <div className='title'>
            <i className='nav-icon-dkv' />
            {I18n.t('plugins_club_salud_title')}
          </div>
          <div className='action-buttons-container'>
            <i className={`fa fa-chevron-${open ? 'up' : 'down'}`} onClick={() => this.onToggle(user.isRemoveByUser)} />
          </div>
        </div>
        <Collapse isOpen={open}>
          <div className='separator' />
          <Card className='mt-3 content-container'>
            <CardBody>
              <CustomPayment tabId='customPayment' user={user} />
            </CardBody>
          </Card>
        </Collapse>
      </div>
    )
  }
}
